import React from "react";

const INDUSTRIES = [
  {
    id: "restaurants",
    title: "Restaurants",
    image:
      "https://images.unsplash.com/photo-1578474846511-04ba529f0b88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjByZXN0YXVyYW50JTIwZGluaW5nJTIwbW9kZXJufGVufDB8fHx8MTc4MTIwNzEyNXww&ixlib=rb-4.1.0&q=85",
    kpi: "Bookings +38%",
    blurb: "Reservation AI, menu chatbot and review automation.",
  },
  {
    id: "barbershops",
    title: "Barbershops",
    image:
      "https://images.unsplash.com/photo-1759134198561-e2041049419c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXJiZXJzaG9wJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgxMjA3MTI1fDA&ixlib=rb-4.1.0&q=85",
    kpi: "No-shows −51%",
    blurb: "Booking assistant, reminders and loyalty AI.",
  },
  {
    id: "mechanics",
    title: "Mechanics",
    image:
      "https://images.unsplash.com/photo-1570129476815-ba368ac77013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhdXRvJTIwbWVjaGFuaWMlMjBnYXJhZ2UlMjBjbGVhbnxlbnwwfHx8fDE3ODEyMDcxMzZ8MA&ixlib=rb-4.1.0&q=85",
    kpi: "Quote-to-job 2.4×",
    blurb: "Service intake automation and parts ordering AI.",
  },
  {
    id: "law-firms",
    title: "Law Firms",
    image:
      "https://images.pexels.com/photos/6077091/pexels-photo-6077091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    kpi: "Intake −63% time",
    blurb: "Client intake, document review and compliance dashboards.",
  },
  {
    id: "home-services",
    title: "Home Services",
    image:
      "https://images.unsplash.com/photo-1620653713380-7a34b773fef8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwc2VydmljZXMlMjBwbHVtYmVyJTIwaHZhY3xlbnwwfHx8fDE3ODEyMDcxMzZ8MA&ixlib=rb-4.1.0&q=85",
    kpi: "Dispatch +29%",
    blurb: "Dispatch AI, quote-to-booking and customer recovery.",
  },
  {
    id: "financial-services",
    title: "Financial Services",
    image:
      "https://images.unsplash.com/photo-1560179707-f14e90ef3623?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBnbGFzcyUyMGJ1aWxkaW5nJTIwbmF2eSUyMHNreXxlbnwwfHx8fDE3ODEyMDcxMjV8MA&ixlib=rb-4.1.0&q=85",
    kpi: "Onboarding −68%",
    blurb: "KYC / AML automation, onboarding and reporting AI.",
  },
];

export const IndustryValidation = () => {
  return (
    <section
      id="validation"
      data-testid="validation-section"
      className="relative py-24 lg:py-32 bg-soft"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div className="text-center">
          <span className="chip">
            <span className="chip-dot" />
            <span className="font-mono text-[12px] text-ink-200">
              Industry Validation
            </span>
          </span>
          <h2
            className="mt-8 headline mx-auto max-w-4xl"
            style={{ fontSize: "clamp(1.85rem, 4.2vw, 3.4rem)" }}
          >
            Validated in the field —{" "}
            <em>across industries.</em>
          </h2>
          <p className="mt-8 max-w-2xl mx-auto text-ink-200/75 text-[16.5px] lg:text-[17px] leading-[1.75] font-light">
            Reference implementations powering real operations, from a
            neighbourhood barbershop to a regulated financial services firm.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((ind) => (
            <article
              key={ind.id}
              data-testid={`industry-card-${ind.id}`}
              className="card-surface overflow-hidden group"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-ink-50">
                <img
                  src={ind.image}
                  alt={ind.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1000ms] group-hover:scale-[1.05]"
                  style={{
                    filter: "grayscale(1) contrast(1.05) brightness(0.92)",
                  }}
                />
                {/* Cool slate/blue tone overlay */}
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(15,23,42,0.20) 0%, rgba(30,58,138,0.35) 60%, rgba(11,14,20,0.78) 100%)",
                  }}
                />
                {/* Subtle scan line / grain */}
                <div
                  className="absolute inset-0 mix-blend-overlay opacity-30"
                  style={{
                    backgroundImage:
                      "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)",
                    backgroundSize: "3px 3px",
                  }}
                />
                <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                  <h3
                    className="text-white text-[22px] tracking-tight"
                    style={{ fontWeight: 500, letterSpacing: "-0.025em" }}
                  >
                    {ind.title}
                  </h3>
                  <span className="font-mono text-[11px] tracking-tight text-white/90 border border-white/25 px-2.5 py-1 rounded-full">
                    {ind.kpi}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <p className="text-[14.5px] leading-[1.65] text-ink-200/75 font-light">
                  {ind.blurb}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryValidation;
